const EXCEL_CONTENT_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export async function readExcelExportResponse(response) {
  const contentType = response.headers.get('content-type')?.toLowerCase() || '';
  if (response.ok && contentType.includes(EXCEL_CONTENT_TYPE)) {
    return response.blob();
  }

  let failure;
  try {
    failure = await response.json();
  } catch (_) {
    // An HTTP error can also have an empty or non-JSON response body.
  }
  const error = new Error(failure?.msg || '导出失败，请稍后再试');
  error.status = response.status;
  error.code = failure?.code;
  throw error;
}
